import { TitleCasePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "../../../app-main.service";
import { AppMainComponent } from "../../../app.main.component";
import { ShippingService } from "./shipping.service";
import * as _ from "lodash";
import { AccountUserService } from "../../../service/account.service";
import { addInList } from "../../../modules/shared/helpers";
import { Status } from "../../../inventory/constants/constants";
import { environment } from "src/environments/environment";
@Component({
    selector: "app-shipping",
    templateUrl: "./shipping.component.html",
    styleUrls: ["./shipping.component.scss"],
})
export class ShippingComponent implements OnInit {
    assestBaseUrl: string = environment.assestsBasePath;
    // @ViewChild("placesRef") placesRef: GooglePlaceDirective;
    // products = [
    //     {
    //         id: 1,
    //         name: "EasyPost",
    //         img: "easypost.png",
    //         description: "EasyPost",
    //         type: "",
    //         installed: false,
    //         showSpin: false,
    //         showDetailBtn: false,
    //     },
    //     {
    //         id: 2,
    //         name: "UPS",
    //         img: "ups.png",
    //         description: "UPS",
    //         type: "",
    //         installed: false,
    //         showSpin: false,
    //         showDetailBtn: false,
    //     },
    //     {
    //         id: 3,
    //         name: "FedEx",
    //         img: "fedex.png",
    //         description: "FedEx",
    //         type: "",
    //         installed: false,
    //         showSpin: false,
    //         showDetailBtn: false,
    //     },
    // ];
    products: any[] = [];
    dataView = true;
    testMode = false;
    key;
    addressMode = false;
    easypostInfo;
    easyPostdetails;
    easyPostForm: FormGroup;

    fedexForm: FormGroup;
    fedexAddressForm: FormGroup;

    upsForm: FormGroup;

    product;
    val: boolean;
    windowRef;

    fedexTB = [
        {
            id: 1,
            name: "LionODev",
            number: "XXX780",
            status: "Completed",
            isActive: true,
            isDefault: true,
        },
        {
            id: 2,
            name: "Test",
            number: "XXX992",
            status: "Completed",
            isActive: true,
            isDefault: false,
        },
    ];
    displayAddFedexData = false;
    displayStatusDetails = false;
    agreed: boolean;
    isDisabled = false;

    fedexAccounts: any[] = [];

    // fedex data
    formattedAddress;
    selectedState;
    zipCode;
    lattitude = 0;
    longitude = 0;
    addressInput = "";
    streetAddress2 = "";
    ErrorMessageSetLocation = "";
    country: any[] = [];
    selectedCountry;
    states: any[] = [];
    selectedStates;
    city: any[] = [];
    selectedCity;
    addressTypes: any[] = [];
    fedexInfo;
    upsInfo;
    upsClientId;

    constructor(
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private shippingService: ShippingService,
        private titlecasePipe: TitleCasePipe,
        public app: AppMainComponent,
        private fb: FormBuilder,
        private accountService: AccountUserService
    ) { }

    ngOnInit(): void {
        this.getAllVendors();
        this.getAllCountry();
        this.getAllAddressTypes();

        this.initEasyPostForm();
        this.initFedexForm();
        this.initUpsForm();
        this.initFedexAddressForm();

        this.fedexAddressForm
            .get("isProduction")!
            .valueChanges.subscribe((val) => {
                this.fedexAddressForm.controls["isProduction"].setValue(val, {
                    emitEvent: false,
                });
            });
    }

    initEasyPostForm() {
        this.easyPostForm = this.fb.group({
            id: [0],
            isProduction: [false],
            clientSecret: ["", Validators.required],
            verifyAddress: [false],
        });
    }

    initUpsForm() {
        this.upsForm = this.fb.group({
            id: [0],
            isProduction: [false],
            verifyAddress: [false],
        });
    }

    initFedexForm() {
        this.fedexForm = this.fb.group({
            id: [0],
            isProduction: [false],
            verifyAddress: [false],
        });
    }

    initFedexAddressForm(length = 9) {
        this.fedexAddressForm = this.fb.group({
            id: [0],
            accName: ["", Validators.required],
            accNo: [
                "",
                [
                    Validators.required,
                    Validators.maxLength(length),
                    Validators.minLength(length),
                ],
            ],
            isProduction: ["No", Validators.required],
            isActive: [true],
        });
    }

    getAllVendors() {
        this.products = [];
        const vendors: any[] = [];

        this.shippingService.getAllCategory().subscribe(
            (res) => {
                if (res && res.length) {
                    const shipCategory = res.filter(
                        (r) => r?.name?.toLowerCase() == "shipping"
                    )[0];
                    this.shippingService
                        .getAllVendorsByCategoryId(shipCategory?.id)
                        .subscribe(
                            (res) => {
                                this.easypostInfo = res.filter(
                                    (r) => r?.name?.toLowerCase() == "easy post"
                                )[0];
                                this.fedexInfo = res.filter(
                                    (r) => r?.name?.toLowerCase() == "fedex"
                                )[0];
                                this.upsInfo = res.filter(
                                    (r) => r?.name?.toLowerCase() == "ups"
                                )[0];

                                if (this.easypostInfo) {
                                    const easypostObj = _.cloneDeep(
                                        this.easypostInfo
                                    );
                                    easypostObj["img"] = "easypost.png";
                                    easypostObj["showSpin"] = false;
                                    easypostObj["showDetailBtn"] =
                                        easypostObj.isInstalled ? true : false;
                                    vendors.push(easypostObj);
                                }

                                if (this.fedexInfo) {
                                    const fedexObj = _.cloneDeep(
                                        this.fedexInfo
                                    );
                                    fedexObj["img"] = "fedex.png";
                                    fedexObj["showSpin"] = false;
                                    fedexObj["showDetailBtn"] =
                                        fedexObj.isInstalled ? true : false;
                                    vendors.push(fedexObj);
                                }

                                if (this.upsInfo) {
                                    const upsObj = _.cloneDeep(this.upsInfo);
                                    upsObj["img"] = "ups.png";
                                    upsObj["showSpin"] = false;
                                    upsObj["showDetailBtn"] = upsObj.isInstalled
                                        ? true
                                        : false;
                                    vendors.push(upsObj);
                                }
                                this.products = vendors;
                            },
                            (error) => {
                                this.messageService.add({
                                    severity: "error",
                                    summary:
                                        this.titlecasePipe.transform("error"),
                                    detail: "Error occurred...",
                                });
                            }
                        );
                }
            },
            (error) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: "Error occurred...",
                });
            }
        );
    }

    installVendor(c) {
        this.confirmationService.confirm({
            message: "Are you sure that you want to proceed?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept: () => {
                c.showSpin = true;
                if (c?.name?.toLowerCase() == "easy post") {
                    this.installEasyPost(c);
                } else if (c?.name?.toLowerCase() == "fedex") {
                    this.installFedexOrUps(c, this.fedexInfo.id);
                } else if (c?.name?.toLowerCase() == "ups") {
                    this.installFedexOrUps(c, this.upsInfo.id);
                } else {
                    setTimeout(() => {
                        c.isInstalled = true;
                        c.showSpin = false;
                        c.showDetailBtn = true;
                    }, 5000);
                }
            },
        });
    }

    installEasyPost(c) {
        const data = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: new Date().toISOString(),
            updatedDate: new Date().toISOString(),
            name: "Easy Post",
            description: "Easy Post",
            vendorId: this.easypostInfo.id,
            vendor: null,
            applicationId: "",
            clientId: "",
            clientSecret: "",
            registrationURL: "",
            redirectURL: "",
            statusId: 1,
            status: null,
            isValid: true,
            validFromDate: "2022-07-18T13:29:02.319Z",
            validToDate: "2022-07-18T13:29:02.319Z",
            organizationId: this.app.companyId,
            key1: "",
            value1: "",
        };

        this.shippingService.addVendorRegistration(data).subscribe(
            (res) => {
                c.showSpin = false;
                this.getAllVendors();
            },
            (error) => {
                c.showSpin = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: "Error occurred...",
                });
            }
        );
    }

    installFedexOrUps(c, id) {
        this.shippingService.installFedexOrUps(id).subscribe(
            (res) => {
                c.showSpin = false;
                this.getAllVendors();
                this.messageService.add({
                    severity: "success",
                    summary: this.titlecasePipe.transform("success"),
                    detail: "Installed Successfully...",
                });
            },
            (error) => {
                c.showSpin = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: "Error occurred...",
                });
            }
        );
    }

    uninstallVendor(c) {
        this.confirmationService.confirm({
            message: "Are you sure that you want to proceed?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept: () => {
                c.showSpin = true;
                if (c?.name?.toLowerCase() == "easy post") {
                    this.uninstallEasyPost(c);
                } else if (c?.name?.toLowerCase() == "fedex") {
                    this.uninstallFedexOrUps(c, this.fedexInfo.id);
                } else if (c?.name?.toLowerCase() == "ups") {
                    this.uninstallFedexOrUps(c, this.upsInfo.id);
                }
            },
        });
    }

    uninstallEasyPost(c) {
        this.shippingService
            .deleteVendor(this.easypostInfo?.vendorOAuthRegistration?.id)
            .subscribe(
                (res) => {
                    c.showSpin = false;
                    this.messageService.add({
                        severity: "success",
                        summary: this.titlecasePipe.transform("success"),
                        detail: "Uninstalled Successfully...",
                    });
                    this.getAllVendors();
                },
                (error) => {
                    c.showSpin = false;
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "Error occurred...",
                    });
                }
            );
    }

    uninstallFedexOrUps(c, id) {
        this.shippingService.uninstallFedexOrUps(id).subscribe(
            (res) => {
                c.showSpin = false;
                this.messageService.add({
                    severity: "success",
                    summary: this.titlecasePipe.transform("success"),
                    detail: "Uninstalled Successfully...",
                });
                this.getAllVendors();
            },
            (error) => {
                c.showSpin = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: "Error occurred...",
                });
            }
        );
    }

    backDataView() {
        this.dataView = true;
    }

    detailsObj;
    getVendorDetails(p) {
        this.product = JSON.parse(JSON.stringify(p));
        this.detailsObj = p;
        if (p?.name?.toLowerCase() == "fedex") {
            this.getFedexAccounts(this.fedexInfo.id);
            this.getFedexIsProdAddressVerify();
        } else if (p?.name?.toLowerCase() == "ups") {
            this.getFedexAccounts(this.upsInfo.id);
            this.getUpsIsProdAddressVerify();
        } else {
            this.shippingService
                .getVendorRegistrationByOrganization(this.easypostInfo.id)
                .subscribe(
                    (res) => {
                        this.dataView = false;
                        this.easyPostdetails = res;
                        this.easyPostForm.patchValue({
                            ...this.easyPostdetails,
                        });
                    },
                    (error) => {
                        this.messageService.add({
                            severity: "error",
                            summary: this.titlecasePipe.transform("error"),
                            detail: "Error occurred...",
                        });
                    }
                );
        }
    }

    save() {
        const data = _.cloneDeep(this.easyPostdetails);
        data.isProduction = this.easyPostForm.controls.isProduction.value;
        data.verifyAddress = this.easyPostForm.controls.verifyAddress.value;
        data.clientSecret = this.easyPostForm.controls.clientSecret.value;
        data.applicationId = this.easyPostForm.controls.clientSecret.value;
        data.clientId = this.easyPostForm.controls.clientSecret.value;

        this.shippingService.updateVendorRegistration(data).subscribe(
            (res) => {
                this.messageService.add({
                    severity: "success",
                    summary: this.titlecasePipe.transform("success"),
                    detail: "Saved Successfully...",
                });
            },
            (error) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: "Error occurred...",
                });
            }
        );
    }

    saveUpsIsProdAndAddressVerifyInfo() {
        this.shippingService
            .saveUpsIsProdAndAddressVerifyInfo(
                this.upsForm.value.isProduction,
                this.upsForm.value.verifyAddress,
                this.upsInfo.id
            )
            .subscribe(
                (result) => {
                    this.messageService.add({
                        severity: "success",
                        summary: this.titlecasePipe.transform("success"),
                        detail: "Saved Successfully...",
                    });
                },
                (error) => {
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "Error occurred...",
                    });
                }
            );
    }

    saveFedexIsProdAndAddressVerifyInfo() {
        this.shippingService
            .saveFedexIsProdAndAddressVerifyInfo(
                this.fedexForm.value.isProduction,
                this.fedexForm.value.verifyAddress,
                this.fedexInfo.id
            )
            .subscribe(
                (result) => {
                    this.messageService.add({
                        severity: "success",
                        summary: this.titlecasePipe.transform("success"),
                        detail: "Saved Successfully...",
                    });
                },
                (error) => {
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "Error occurred...",
                    });
                }
            );
    }

    saveFedexAccountInfo() {
        let isDuplicateAccNo = false;
        if (
            this.fedexAddressForm.controls.accNo.value &&
            this.fedexAccounts &&
            this.fedexAccounts.length
        ) {
            const acc = this.fedexAccounts.filter(
                (acc) =>
                    acc.accountValue?.accountNumber.trim() ==
                    this.fedexAddressForm.controls.accNo.value.trim()
            )[0];
            isDuplicateAccNo = acc ? true : false;
        }

        if (!isDuplicateAccNo) {
            const loggedinUser = this.accountService.userValue;
            const accDetails = {
                accountNumber: this.fedexAddressForm.controls.accNo.value,
                accountName: this.fedexAddressForm.controls.accName.value,
                isActive: this.fedexAddressForm.controls.isActive.value,
                isDefault:
                    this.fedexAccounts && this.fedexAccounts.length
                        ? false
                        : true,
                isLicenseAgreed: this.agreed,
            };
            let accDetailsObjEncStr = btoa(JSON.stringify(accDetails));

            const address = {
                streetAddress1: this.formattedAddress,
                streetAddress2: this.streetAddress2,
                cityId: this.selectedCity ? this.selectedCity.id : null,
                stateId: this.selectedState ? this.selectedState.id : null,
                countryId: this.selectedCountry
                    ? this.selectedCountry.id
                    : null,
                zipCode: this.zipCode,
                // addressTypeId: this.addressTypes.filter(
                //     (a) => a?.name.toLowerCase() == "billing"
                // )[0]?.id,
                addressTypeId: 38, // todo remove once api fixed

                city: null,
                state: null,
                country: null,
                statusId: Status.Active,
                isDefault:
                    this.fedexAccounts && this.fedexAccounts.length
                        ? false
                        : true,
            };
            let addressObjEncStr = btoa(JSON.stringify(address));
            const isProd =
                this.fedexAddressForm.controls.isProduction.value &&
                    this.fedexAddressForm.controls.isProduction.value == "Yes"
                    ? true
                    : false;

            const id =
                this.detailsObj?.name?.toLowerCase() == "fedex"
                    ? this.fedexInfo.id
                    : this.detailsObj?.name?.toLowerCase() == "ups"
                        ? this.upsInfo.id
                        : 0;
            this.shippingService
                .saveFedexAccountInfo(
                    isProd,
                    accDetailsObjEncStr,
                    addressObjEncStr,
                    id
                )
                .subscribe(
                    (result) => {
                        this.messageService.add({
                            severity: "success",
                            summary: this.titlecasePipe.transform("success"),
                            detail: "Saved Successfully...",
                        });
                        this.displayAddFedexData = false;
                        if (this.detailsObj?.name?.toLowerCase() == "fedex") {
                            this.getFedexAccounts(this.fedexInfo.id);
                            this.getFedexIsProdAddressVerify();
                        } else if (
                            this.detailsObj?.name?.toLowerCase() == "ups"
                        ) {
                            this.getFedexAccounts(this.upsInfo.id);
                            this.getUpsIsProdAddressVerify();
                        }
                    },
                    (error) => {
                        console.log(error);
                        this.messageService.add({
                            severity: "error",
                            summary: this.titlecasePipe.transform("error"),
                            detail: "Error occurred...",
                        });
                    }
                );
        } else {
            this.messageService.add({
                severity: "error",
                summary: this.titlecasePipe.transform("error"),
                detail: "Account No already exists.. Please Check",
            });
        }
    }

    getFedexIsProdAddressVerify() {
        this.initFedexForm();
        this.shippingService
            .getFedexIsProdAddressVerify(this.fedexInfo.id)
            .subscribe(
                (res) => {
                    this.fedexForm.patchValue({
                        isProduction: res?.isProduction,
                        verifyAddress: res?.verifyAddress,
                    });
                },
                (error) => {
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "Error occurred...",
                    });
                }
            );
    }

    getUpsIsProdAddressVerify() {
        this.initUpsForm();
        this.shippingService
            .getUpsIsProdAddressVerify(this.upsInfo.id)
            .subscribe(
                (res) => {
                    this.dataView = false;
                    this.upsForm.patchValue({
                        isProduction: res?.isProduction,
                        verifyAddress: res?.verifyAddress,
                    });
                },
                (error) => {
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "Error occurred...",
                    });
                }
            );
    }

    getFedexAccounts(id) {
        const loggedinUser = this.accountService.userValue;
        const organizationId = loggedinUser.organizationId;

        this.shippingService
            .getFedexAccounts(organizationId, id)
            .subscribe((res) => {
                this.dataView = false;
                this.fedexAccounts = [];
                if (res && res.length) {
                    res.forEach((acc) => {
                        const obj = acc;

                        // format
                        if (acc.accountDetails) {
                            const textarray = acc.accountDetails.split(";");
                            let addValue = "";
                            let accValue = "";
                            if (textarray && textarray.length > 0) {
                                addValue = textarray[0].substring(
                                    13,
                                    textarray[0].length
                                );
                            }
                            if (textarray && textarray.length > 0) {
                                accValue = textarray[1].substring(
                                    13,
                                    textarray[1].length
                                );
                            }
                            obj["addressValue"] = JSON.parse(atob(addValue));
                            obj["accountValue"] = JSON.parse(atob(accValue));
                        }
                        obj.isDefault = obj.isDefault == "true" ? true : false;
                        this.fedexAccounts.push(obj);
                    });
                }
            });
    }

    configure(name) {
        if (name?.toLowerCase() == "fedex") {
            // this.installFedex();
        } else {
            this.configureUps();
        }
    }

    configureUps() {
        const loggedinUser = this.accountService.userValue;
        let userInfo = {
            organizationId: loggedinUser.organizationId,
            userId: loggedinUser.userId,
            vendorId: this.upsInfo.id,
            clientIP: this.upsInfo.createdSource,
            loginAuditId: loggedinUser.loginAuditId,
            sessionId: localStorage.getItem("randomstr"),
            sourceType: "Web",
        };
        let objEncStr = btoa(JSON.stringify(userInfo));

        this.shippingService
            .upsValidateClient(objEncStr)
            .subscribe((result) => {
                this.upsClientId = result?.clientId;
                this.windowRef = window.open(
                    `${result?.lassoRedirectURL}?client_id=${result?.clientId}&redirect_uri=${result?.redirectURL}&response_type=code&scope=read&type=ups_com_api`,
                    "child",
                    "toolbar=no,location=no,directories=no,status=no,menubar=no,titlebar=no,fullscreen=no,scrollbars=1,resizable=no,width=1000,height=650,left=200,top=100"
                );
            });

        let windowRefInterval = setInterval(() => {
            const href = this.windowRef.location.href;
            if (href != null) {
                const found = href.includes("?code=");
                if (found) {
                    if (this.windowRef) {
                        this.windowRef.close();
                    }
                    clearInterval(windowRefInterval);
                    const d = href.split("?code=");
                    if (d && d.length > 1) {
                        const dArr = d[1].split("&scope=");
                        this.getUpsAccessToken(dArr[0]);
                    }
                }
            }
        }, 3000);
    }

    getUpsAccessToken(authToken) {
        const loggedinUser = this.accountService.userValue;
        this.shippingService
            .getUpsAccessToken(authToken, this.upsInfo.id, null)
            .subscribe(
                (res) => {
                    // console.log(res);
                    this.messageService.add({
                        severity: "success",
                        summary: this.titlecasePipe.transform("success"),
                        detail: "Saved Successfully...",
                    });
                },
                (error) => {
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "Error occurred...",
                    });
                }
            );
    }

    changeFedexDefaultAccount(data) {
        const id =
            this.detailsObj?.name?.toLowerCase() == "fedex"
                ? this.fedexInfo.id
                : this.detailsObj?.name?.toLowerCase() == "ups"
                    ? this.upsInfo.id
                    : 0;

        this.shippingService
            .saveFedexDefaultAccount(data.accountNumber, id)
            .subscribe(
                (res) => {
                    this.messageService.add({
                        severity: "success",
                        summary: this.titlecasePipe.transform("success"),
                        detail: "Saved Successfully...",
                    });
                    if (this.detailsObj?.name?.toLowerCase() == "fedex") {
                        this.getFedexAccounts(this.fedexInfo.id);
                    } else if (this.detailsObj?.name?.toLowerCase() == "ups") {
                        this.getFedexAccounts(this.upsInfo.id);
                    }
                },
                (error) => {
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "Error occurred...",
                    });
                }
            );
    }


    dialogHeader = "";
    accNoLabel = "";
    shippingProvider = "";
    addFedexAccount() {
        if (this.detailsObj?.name?.toLowerCase() == "fedex") {
            this.dialogHeader = "Add FedEx Account";
            this.accNoLabel = "FedEx Account Number (9 digit)";
            this.shippingProvider = 'FedEx';
            this.initFedexAddressForm(9);
        } else if (this.detailsObj?.name?.toLowerCase() == "ups") {
            this.dialogHeader = "Add Ups Account";
            this.accNoLabel = "Ups Account Number (6 digit)";
            this.shippingProvider = 'UPS';
            this.initFedexAddressForm(6);
        }

        this.formattedAddress = "";
        this.streetAddress2 = "";
        this.selectedCity = null;
        this.selectedState = null;
        this.selectedCountry = null;
        this.zipCode = null;
        this.agreed = false;
        this.isDisabled = false;
        this.displayAddFedexData = true;
    }

    async viewFedexAccountDetails(data) {
        this.initFedexAddressForm();
        this.fedexAddressForm.patchValue({
            accName: data?.accountValue?.accountName,
            accNo: data?.accountValue?.accountNumber,
            isActive: data?.accountValue?.isActive,
            isProduction:
                data?.isProduction && data?.isProduction == true ? "Yes" : "No",
        });

        this.formattedAddress = data?.addressValue?.streetAddress1;
        this.streetAddress2 = data?.addressValue?.streetAddress2;
        this.zipCode = data?.addressValue?.zipCode;

        const filteredCountry = this.country?.filter(
            (c) => c.id == data?.addressValue?.countryId
        )[0];
        this.selectedCountry = filteredCountry;
        if (this.selectedCountry) {
            await this.getAsyncStatesFromCountry(this.selectedCountry);
        }

        const filteredState = this.states?.filter(
            (c) => c.id == data?.addressValue?.stateId
        )[0];
        this.selectedState = filteredState;
        if (this.selectedState) {
            await this.getAsyncCitiesFromState(this.selectedState);
        }

        const filteredCity = this.city?.filter(
            (c) => c.id == data?.addressValue?.cityId
        )[0];
        this.selectedCity = filteredCity;
        this.agreed = true;

        this.isDisabled = true;
        this.displayAddFedexData = true;
    }

    deleteFedexAccount(d) {
        // console.log(d);
        this.confirmationService.confirm({
            message: "Do you want to delete?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.appMainService.isShowSpinner("loadVendorRegistration");
                this.shippingService.deleteAccount(d.id).subscribe(
                    (res) => {
                        this.appMainService.isHideSpinner(
                            "loadVendorRegistration"
                        );
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Deleted successfully...",
                        });
                        if (this.detailsObj?.name?.toLowerCase() == "fedex") {
                            this.getFedexAccounts(this.fedexInfo.id);
                        } else if (
                            this.detailsObj?.name?.toLowerCase() == "ups"
                        ) {
                            this.getFedexAccounts(this.upsInfo.id);
                        }
                    },
                    (err) => {
                        this.appMainService.isHideSpinner(
                            "loadVendorRegistration"
                        );
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred...",
                        });
                    }
                );
            },
            reject: () => { },
        });
    }

    openStatusDetails() {
        this.displayStatusDetails = true;
    }

    // fedex address
    async locationAddresChanged(address: any) {
        this.removeAddressLocation();
        //setting address from API to local variable
        this.ErrorMessageSetLocation = "";

        this.formattedAddress = address.formatted_address;
        const googleAddressObj = this.getAddressObj(address);
        setTimeout(() => {
            const da = this.getStreetAddress(googleAddressObj); //updatedAddressLine;
            this.addressInput = da;
            this.formattedAddress = da;
        });

        this.selectedCountry = null;
        this.selectedState = null;
        this.selectedCity = null;
        this.zipCode = "";
        this.lattitude = googleAddressObj.latitude;
        this.longitude = googleAddressObj.latitude;

        let searchedCountry = googleAddressObj.country
            ? (googleAddressObj.country as any).long_name
            : "";
        let searchedZipcode = googleAddressObj.zipCode
            ? (googleAddressObj.zipCode as any).long_name
            : "";
        let searchedState = googleAddressObj.state
            ? (googleAddressObj.state as any).long_name
            : "";
        let searchedCity = googleAddressObj.city
            ? (googleAddressObj.city as any).long_name
            : "";
        if (searchedCountry) {
            let matchedCountry;
            if (
                searchedCountry == "USA" ||
                searchedCountry == "United States"
            ) {
                matchedCountry = this.country.find(
                    (obj) =>
                        obj.name == searchedCountry ||
                        obj.countryCode == (googleAddressObj.country as any)?.short_name
                );
            } else {
                matchedCountry = this.country.find(
                    (obj) => obj.name == searchedCountry
                );
            }

            if (matchedCountry) {
                await this.getAsyncStatesFromCountry(matchedCountry);
                this.selectedCountry = matchedCountry;

                //set state
                let matchedState = this.states.find(
                    (obj) =>
                        obj.name == searchedState ||
                        obj.shortName == (googleAddressObj.state as any)?.short_name
                );
                if (matchedState) {
                    this.selectedState = matchedState;
                } else if (!matchedState) {
                    // add state
                    matchedState = await this.addState(
                        googleAddressObj.state,
                        matchedCountry.id
                    );
                    this.selectedState = matchedState;
                }

                await this.getAsyncCitiesFromState(matchedState);

                if (searchedZipcode) {
                    this.zipCode = searchedZipcode;
                }
                //set city
                let matchedCity = this.city
                    ? this.city.find((obj) => obj.name == searchedCity)
                    : null;
                if (matchedCity) {
                    this.selectedCity = matchedCity;
                } else if (!matchedCity) {
                    matchedCity = await this.addCity(
                        searchedCity,
                        matchedState.id
                    );
                    this.selectedCity = matchedCity;
                }
            }
        }
    }

    removeAddressLocation() {
        this.addressInput = "";
        this.formattedAddress = "";
        this.streetAddress2 = "";
        this.selectedCountry = null;
        this.selectedState = null;
        this.selectedCity = null;
        this.zipCode = "";
    }

    getAddressObj(address) {
        const addressObj = {
            street_number: null,
            subpremise: null,
            plus_code: null,
            neighborhood: null,
            landmark: null,
            route: null,
            sublocality_level_3: null,
            sublocality_level_2: null,
            sublocality_level_1: null,
            locality: null,
            city: null,
            state: null,
            country: null,
            zipCode: null,
            latitude: address.geometry.location.lat(),
            longitude: address.geometry.location.lng(),
        };
        address.address_components.forEach((comp) => {
            const field = comp.types[0];
            if (field == "street_number") {
                addressObj.street_number = comp;
            }
            if (field == "plus_code") {
                addressObj.plus_code = comp;
            }
            if (field == "neighborhood") {
                addressObj.neighborhood = comp;
            }
            if (field == "landmark") {
                addressObj.landmark = comp;
            }
            if (field == "route") {
                addressObj.route = comp;
            }
            if (field == "sublocality_level_3") {
                addressObj.sublocality_level_3 = comp;
            }
            if (field == "sublocality_level_2") {
                addressObj.sublocality_level_2 = comp;
            }
            if (field == "sublocality_level_1") {
                addressObj.sublocality_level_1 = comp;
            }
            if (field == "subpremise") {
                addressObj.subpremise = comp;
            }
            // city
            if (field == "locality") {
                addressObj.locality = comp;
                addressObj.city = comp;
            }
            // // city
            // if(field =='administrative_area_level_2'){
            //     addressObj.city = comp;
            // }
            // state
            if (field == "administrative_area_level_1") {
                addressObj.state = comp;
            }

            if (field == "country") {
                addressObj.country = comp;
            }
            if (field == "postal_code") {
                addressObj.zipCode = comp;
            }
        });
        if (addressObj.city == null) {
            addressObj.city = addressObj.sublocality_level_1;
        }
        return addressObj;
    }

    getStreetAddress(googleAddressObj) {
        const street: any[] = [];
        if (googleAddressObj.plus_code) {
            street.push(googleAddressObj.plus_code.long_name);
        }
        if (googleAddressObj.street_number) {
            street.push(googleAddressObj.street_number.long_name);
        }
        if (googleAddressObj.route) {
            street.push(googleAddressObj.route.long_name);
        }
        if (googleAddressObj.subpremise) {
            street.push(`#${googleAddressObj.subpremise.long_name}`);
        }
        if (googleAddressObj.neighborhood) {
            street.push(googleAddressObj.neighborhood.long_name);
        }
        if (googleAddressObj.sublocality_level_3) {
            street.push(googleAddressObj.sublocality_level_3.long_name);
        }
        if (googleAddressObj.sublocality_level_2) {
            street.push(googleAddressObj.sublocality_level_2.long_name);
        }
        if (
            googleAddressObj.sublocality_level_1 &&
            googleAddressObj.locality != null
        ) {
            street.push(googleAddressObj.sublocality_level_1.long_name);
        }
        return street.length ? street.join(" ") : "";
    }

    onAddressBlur(address) {
        this.addressInput = address;
        this.formattedAddress = this.addressInput;
        if (address == '') {
            this.addressInput = '';
            this.formattedAddress='';
            this.streetAddress2 = "";
            this.selectedCountry = null;
            this.selectedState = null;
            this.selectedCity = null;
            this.zipCode = "";
        }
    }

    async getAsyncStatesFromCountry(country) {
        let countryID = country.id;
        await this.shippingService.getAllStates(countryID).then((states) => {
            this.states = states;
            this.selectedState = null;
        });
    }

    async addState(stateDetails, countryId) {
        const data = {
            id: 0,
            createdSource: this.app.user.userIP,
            updatedSource: null,
            createdBy: this.app.user.userId,
            updatedBy: 0,
            createdDate: new Date(),
            updatedDate: null,
            name: stateDetails.long_name,
            shortName: stateDetails.short_name,
            description: stateDetails.long_name,
            countryId: countryId,
            statusId: 1,
        };
        const newAddedState = await this.shippingService.addState(data);
        this.states = addInList(this.states, newAddedState);
        return newAddedState;
    }

    async getAsyncCitiesFromState(state) {
        await this.shippingService.getAllCities(state.id).then((cities) => {
            this.city = cities;
            this.selectedCity = null;
        });
    }

    async addCity(searchedCityName, stateId) {
        const data = {
            id: 0,
            createdSource: this.app.user.userIP,
            updatedSource: null,
            createdBy: this.app.user.userId,
            updatedBy: 0,
            createdDate: new Date(),
            updatedDate: null,
            name: searchedCityName,
            description: searchedCityName,
            stateId: stateId,
            statusId: 1,
        };
        const newAddedCity = await this.shippingService.addCity(data);
        this.city = addInList(this.city, newAddedCity);
        return newAddedCity;
    }

    getCitiesFromState(state) {
        this.shippingService.getAllCities(state.id).then((cities) => {
            this.city = cities;
        });
    }

    getStatesFromCountry(country) {
        const countryID = country.id;
        this.shippingService.getAllStates(countryID).then((states) => {
            this.states = states;
        });
    }

    getAllCountry() {
        this.shippingService.getCountry().subscribe((country) => {
            this.country = country;
        });
    }

    getAllAddressTypes() {
        this.shippingService.getAddressTypes().subscribe((types) => {
            this.addressTypes = types;
        });
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }
}
